<template>
  <div>
    <!------------ toast / snackbar ------------------------------>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="snackbar"
      :timeout="timeout"
      color="primary"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="primary" size="22"
            >mdi-checkbox-multiple-marked-circle-outline</v-icon
          >
          <span v-if="editvideodialog" class="mt-n1 ml-5 text_style"
            >Update successfully</span
          >
          <span v-if="!editvideodialog" class="mt-n1 ml-5 text_style"
            >Created successfully</span
          >
        </div>
        <div>
          <v-icon color="primary" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="Deletesnackbar"
      :timeout="timeout"
      color="error"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="error" size="22">mdi-alert-circle-outline</v-icon>
          <span class="mt-n1 ml-5 text_style">Delete successfully</span>
        </div>
        <div>
          <v-icon color="error" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <!------------ toast / snackbar ------------------------------>

    <!------------section one--- heading and btns---------------->
    <v-row class="d-flex justify-space-between align-center" flat>
      <v-col cols="12" md="6">
        <h1 class="heading-1 pb-2">Videos</h1>
      </v-col>
      <v-col cols="12" md="6">
        <div class="d-flex justify-end align-center">
          <!--------------organizedialog---------------->
          <v-dialog v-model="organizedialog" persistent max-width="700">
            <v-card>
              <div class="mx-5 py-5 d-flex justify-space-between">
                <div class="d-flex align-center">
                  <span class="h5 mb-1">Organize</span>
                  <v-dialog
                    v-model="newcategorydialog"
                    persistent
                    max-width="450"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        text
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="text_style"
                      >
                        + Create Category
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="py-5 d-flex justify-space-between">
                        <h5 class="text_style">Add Category</h5>
                        <v-icon @click="closeCategorydialog()"
                          >mdi-close</v-icon
                        >
                      </v-card-title>

                      <v-card color="#F6F8FC" flat class="py-5 px-3 my-8">
                        <v-text-field
                          :error-messages="
                            $v.form.Name.$error ? 'Name is required' : null
                          "
                          label="Name Category"
                          required
                          v-model="form.Name"
                        ></v-text-field>
                      </v-card>
                      <v-card-actions class="pb-8 pt-8">
                        <v-spacer></v-spacer>
                        <v-btn
                          class="px-14 py-5"
                          text
                          @click="closeCategorydialog()"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          :disabled="disabledSavebtn"
                          color="primary"
                          @click="send()"
                        >
                          <v-progress-circular
                            indeterminate
                            size="20"
                            class="px-5"
                            color="white"
                            v-show="btnloader"
                          ></v-progress-circular>
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                <v-icon @click="organizedialog = false">mdi-close</v-icon>
              </div>
              <OrganizeComponent
                :organizeDialog="organizedialog"
                @close="close"
                @fetchData="fetchCategoryData"
              ></OrganizeComponent>

              <!-- <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="px-14 py-6 mb-2 text_trans"
                    color="grey lighten-1"
                    text
                    @click="organizedialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="px-14 py-6 mb-2 text_trans"
                    @click="organizedialog = false"
                  >
                    save
                  </v-btn>
                </v-card-actions> -->
            </v-card>
          </v-dialog>
          <!---------end-----organizedialog---------------->
          <!-------------add_dialog---------------->
          <v-dialog
            v-model="add_dialog"
            persistent
            max-width="600"
            style="overflow-y: hidden"
          >
            <v-card>
              <div class="mx-5 py-5 d-flex justify-space-between">
                <h5>New Video</h5>
                <v-icon @click="add_dialog = false">mdi-close</v-icon>
              </div>
              <addnewvideo-component
                v-if="add_dialog"
                :add_dialog="add_dialog"
                :selectedImage="selectedImage"
                @close="close"
                @fetchVideosList="fetchVideosList"
              />
            </v-card>
          </v-dialog>
          <!----------end---add_dialog---------------->
          <div class="add_orgranize_btn_destop">
            <v-btn
              depressed
              color="primary"
              dark
              outlined
              @click.stop="organizedialog = true"
              class="text_style px-11 mr-4"
            >
              Organize
            </v-btn>
            <v-btn
              depressed
              color="primary"
              dark
              @click="randomImageSelection()"
              class="text_style px-7"
            >
              Add New video
            </v-btn>
          </div>
        </div>
        <div class="add_orgranize_btn_mobile">
          <v-row>
            <v-col cols="12"
              ><v-btn
                depressed
                color="primary"
                dark
                outlined
                block
                v-if="Permission.Add"
                @click.stop="organizedialog = true"
                class="text_style"
              >
                Organize
              </v-btn></v-col
            >
            <v-col cols="12">
              <v-btn
                depressed
                color="primary"
                dark
                block
                v-if="Permission.Add"
                @click.stop="add_dialog = true"
                class="text_style"
              >
                Add New video
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <!------------section two- search and filter------------------>
    <div class="my-3">
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              hide-details
              single-line
              @input="searchData()"
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialog = true"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title
                class="mb-5 d-flex justify-space-between align-center"
              >
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span
                      class="text_style primary--text"
                      style="letter-spacing: 0px"
                      >Clean filters</span
                    >
                  </v-btn>
                  <v-icon class="ml-3" @click="filterDialog = false"
                    >mdi-close</v-icon
                  >
                </div>
              </v-card-title>

              <v-card-text>
                <v-select
                  outlined
                  class="my-5"
                  v-model="filterObj.CategoryId"
                  :items="GetVideosCategory"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Category"
                  item-text="Name"
                  item-value="Id"
                  multiple
                  persistent-hint
                ></v-select>
                <v-select
                  outlined
                  class="my-5"
                  v-model="filterObj.Modality"
                  :items="filterModalityList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Modality"
                  item-text="Name"
                  item-value="Id"
                  multiple
                  persistent-hint
                ></v-select>

                <!-- <v-select
                    outlined
                    v-model="filterObj.SubmittedBy"
                    :items="GetSiteUser"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="By Submitted"
                    item-text="FirstName"
                    item-value="Id"
                    multiple
                    persistent-hint
                  ></v-select> -->

                <v-select
                  class="my-5"
                  outlined
                  :items="filtervisbiltyList"
                  v-model="filterObj.Visibility"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Visibility"
                  persistent-hint
                ></v-select>

                <!-- <v-select
                    :items="getMembership"
                    v-model="filterObj.MembershipsId"
                    :menu-props="{ maxHeight: '400' }"
                    item-text="Name"
                    item-value="Id"
                    outlined
                    class="my-5"
                    dense
                    hide-details
                    label=" Membership Type"
                    multiple
                    persistent-hint
                  ></v-select> -->

                <!-- <v-select
                    :items="GetCourses"
                    v-model="filterObj.CoursesId"
                    item-text="Title"
                    item-value="Id"
                    :menu-props="{ maxHeight: '400' }"
                    outlined
                    class="my-5"
                    dense
                    hide-details
                    label="Course Prerequisites"
                    persistent-hint
                  ></v-select> -->

                <!-- <v-select
                    :items="Credentials"
                    v-model="filterObj.Credential"
                    :menu-props="{ maxHeight: '400' }"
                    outlined
                    class="my-5"
                    dense
                    hide-details
                    label="Credentials"
                    persistent-hint
                  ></v-select> -->

                <!-- <v-select
                    outlined
                    class="my-5"
                    :items="InstructorsArray"
                    item-text="Name"
                    item-value="InstructorId"
                    v-model="filterObj.InstructorId"
                    :menu-props="{ maxHeight: '400' }"
                    dense
                    hide-details
                    label=" Instructor - Courses Taught"
                    persistent-hint
                  ></v-select> -->
                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#646464"
                  outlined
                  depressed
                  class="px-5"
                  text
                  @click="filterDialog = false"
                >
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-8 ml-2"
                  @click="sendFilters()"
                  depressed
                >
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>
    <!------------section three- datatable ------------------>
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :items="Fitems"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :search="search"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <b>
            {{
              search
                ? index + 1
                : index + displayedItemsPerPage * (page - 1) + 1
            }}
          </b>
        </template>
        <template v-slot:[`item.images`]="{ item }">
          <v-card
            flat
            color="transparent"
            style="max-width: fit-content"
            class="pa-1"
          >
            <v-img
              :src="concatBaseUrl(item.images)"
              alt="John"
              height="50"
              width="80"
            />
          </v-card>
        </template>
        <template v-slot:[`item.Title`]="{ item }">
          <span class="table_style_one"> {{ item.Title }} </span>
        </template>
        <template v-slot:[`item.CategoryId`]="{ item }">
          <span class="table_style_two"> {{ item.CategoryId }} </span>
        </template>
        <template v-slot:[`item.Modality`]="{ item }">
          <span class="table_style_two"> {{ item.Modality }} </span>
        </template>
        <template v-slot:[`item.SubmittedBy`]="{ item }">
          <span class="table_style_two"> {{ item.SubmittedBy }} </span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="toggleIsPlaying(item.Id)" class="mx-5">
            <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="preview(item)"
                >
                  <v-icon color="#646464">mdi-account-circle</v-icon>
                  <span class="ml-4 text_style">Preview Video</span>
                </v-btn>
              </v-list>
              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Edit"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="editRow(item)"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Delete"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="deleteRow(item)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @input="handleItemPerPageChange"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchVideosList"
      ></v-pagination
    ></v-card>
    <!---------------Preview vedio dialog------------------------->
    <v-dialog v-model="previewvideodialog2" persistent max-width="1000">
      <v-card>
        <div v-if="test">
          <PreviewvedioComponent
            @close="close"
            :selectedRowData="selectedRowData"
          ></PreviewvedioComponent>
        </div>
        <div class="d-flex justify-end mx-5 py-5">
          <v-btn color="warning" text @click="closePlayer()"> Cancel </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!---------------Edit vedio dialog------------------------->
    <v-dialog v-model="editvideodialog" persistent max-width="600">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <h5>Edit</h5>
          <v-icon @click="editvideodialog = false">mdi-close</v-icon>
        </div>
        <div v-if="editvideodialog">
          <addnewvideo-component
            v-if="editvideodialog"
            @close="close"
            @fetchVideosList="fetchVideosList"
            :editDialog="editvideodialog"
            :selectedImage="selectedImage"
            :selectedRowData="selectedRowData"
          />
        </div>
      </v-card>
    </v-dialog>
    <!---------------Delete vedio dialog------------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="btnloader"
            @click="DeleteVideoFile()"
          >
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PreviewvedioComponent from "../../components/Video/previewvideo.component.vue";
import AddnewvideoComponent from "../../components/Video/addnewvideo.component.vue";
import OrganizeComponent from "../../components/Video/organize.component.vue";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    OrganizeComponent,
    AddnewvideoComponent,
    PreviewvedioComponent,
    // EditVideoComponent,
  },
  data() {
    return {
      totalRecords: null,
      filterObj: {},

      filterModality: [],
      filterModalityList: [
        "BodyTalk",
        "BodyTalk for Animals",
        "BodyTalk Access",
        "MindScape",
        "BreakThrough",
        "FreeFall",
        "PaRama",
      ],
      Credentials: [" CBP", "CBP-A", "AdvCBP", "PaRamaCBP", "BAT", "CBI"],
      disabledSavebtn: false,
      filterDialog: false,
      page: 1,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      snackbar: false,
      Deletesnackbar: false,
      selectedRowData: {},
      timeout: 1500,
      dialog: false,
      tableLoader: false,
      btnloader: false,
      isPlaying: false,
      editvideodialog: false,
      newcategorydialog: false,
      previewvideodialog2: false,
      organizedialog: false,
      add_dialog: false,
      EditvideoModel: {},
      test: true,
      selectedImage: "",
      search: "",
      filter: "",
      filtervisbiltyList: ["Yes", "No"],
      pageSize: 10,
      filterItem: [
        {
          text: "By Category",
        },
        {
          text: "By Visibility",
        },
        {
          text: "By Submitted ",
        },
        {
          text: "By Modality ",
        },
      ],
      ibaImages: [
        require("@/assets/images/_Generic1.jpg"),
        require("@/assets/images/_Generic2.jpg"),
        require("@/assets/images/_Generic3.jpg"),
        require("@/assets/images/_Generic6.jpg"),
        require("@/assets/images/_Generic8.jpg"),
        require("@/assets/images/_Generic15.jpg"),
      ],
      headers: [
        { text: "#", value: "index" },
        { text: "Thumbnail", value: "images" },
        { text: "Title", value: "Title" },
        { text: "Category", value: "CategoryName" },
        { text: "Modality", value: "Modality" },
        { text: "Submitted by", value: "SubmittedByName" },
        { text: "", value: "actions", sortable: false },
      ],
      form: {
        Name: "",
      },
      videoDataTableOne: [],
      Fitems: [],
      filtersArray: [],
    };
  },
  validations: {
    form: {
      Name: { required },
    },
  },
  computed: {
    ...mapGetters([
      "GetUserRolePermissions",
      "GetVideosCategory",
      "GetSiteUser",
      "getMembership",
      "GetCourses",
      "getMembership",
      "GetVideosList",
    ]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetVideosList.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Videos"
    );
    this.tableLoader = true;
    this.fetchData()
  },
  watch: {
    search() {
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.fetchVideosList();
      }, 700);
    },
  },
  methods: {
    async fetchData(){
      await this.fetchVideosList();
      await this.fetchCategoryData();
      await this.$store.dispatch("getMembership");
    },
    concatBaseUrl(image) {
      if (image.includes("Generic")) {
        return image;
      } else {
        // return process.env.VUE_APP_IMG_URL + image;
        return image;
      }
    },
    handleItemPerPageChange() {
      this.page = 1;
      this.fetchVideosList();
    },
    randomImageSelection() {
      this.add_dialog = true;
      const randomIndex = Math.floor(Math.random() * this.ibaImages.length);
      this.selectedImage = this.ibaImages[randomIndex];
    },
    sendFilters() {
      this.filtersArray = [];
      if (this.filterObj.CategoryId && this.filterObj.CategoryId.length > 0) {
        this.filtersArray.push({
          Key: "CategoryId",
          Value: this.filterObj.CategoryId.join(","),
        });
      }
      if (this.filterObj.Modality && this.filterObj.Modality.length > 0) {
        this.filtersArray.push({
          Key: "Modality",
          Value: this.filterObj.Modality.join(","),
        });
      }
      // if (this.filterObj.Languages && this.filterObj.Languages.length > 0) {
      //   this.filtersArray.push({
      //     Key: "Languages",
      //     Value: this.filterObj.Languages.join(","),
      //   });
      // }

      // if (this.filterObj.SubmittedBy && this.filterObj.SubmittedBy.length > 0) {
      //   this.filtersArray.push({
      //     Key: "SubmittedBy",
      //     Value: this.filterObj.SubmittedBy.join(","),
      //   });
      // }

      if (this.filterObj.Visibility && this.filterObj.Visibility.length > 0) {
        this.filtersArray.push({
          Key: "Visibility",
          Value: this.filterObj.Visibility,
        });
      }

      // if (
      //   this.filterObj.MembershipsId &&
      //   this.filterObj.MembershipsId.length > 0
      // ) {
      //   this.filtersArray.push({
      //     Key: "MembershipTypes",
      //     Value: this.filterObj.MembershipsId.join(","),
      //   });
      // }

      // if (this.filterObj.CoursesId) {
      //   this.filtersArray.push({
      //     Key: "CoursePrerequisites",
      //     Value: this.filterObj.CoursesId,
      //   });
      // }

      // if (this.filterObj.Credential) {
      //   this.filtersArray.push({
      //     Key: "Credential",
      //     Value: this.filterObj.Credential,
      //   });
      // }

      // if (this.filterObj.Permissions && this.filterObj.Permissions.length > 0) {
      //   this.filtersArray.push({
      //     Key: "PractitionerLevels",
      //     Value: this.filterObj.Permissions.join(","),
      //   });
      // }

      // if (this.filterObj.InstructorId) {
      //   this.filtersArray.push({
      //     Key: "Instructors",
      //     Value: this.filterObj.InstructorId,
      //   });
      // }
      this.fetchVideosList();
    },
    deleteRow(row) {
      this.DeleteVideo = row.Id;
      this.dialog = true;
    },
    DeleteVideoFile() {
      this.btnloader = true;
      const Id = this.DeleteVideo;
      this.$store.dispatch("DeleteVideo", Id).then((res) => {
        if (res.Status) {
          this.dialog = false;
          this.btnloader = false;
          this.fetchVideosList();
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      });
    },
    async fetchVideosList() {
      let apiParam = {
        page: this.search ? 1 : this.page,
        pageSize: this.itemsPerPage === "All" ? 10000 : this.itemsPerPage,
        search: this.search,
        categories: JSON.stringify(this.filtersArray),
      };
      this.tableLoader = true;
      await this.$store.dispatch("GetVideosList", apiParam).then((res) => {
        this.totalRecords = res.Data.totalRecords;
        this.videoDataTableOne = res?.Data?.List?.map((x, i) => ({
          index: i + 1,
          images: x?.ThumbnailImage
            ? x?.ThumbnailImage
            : "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&w=1000&q=80",
          Title: x?.Title,
          SubmittedBy: x?.SubmittedBy,
          Modality: x?.Modality,
          CategoryId: x?.CategoryId,
          Videourl:
            x?.VideoUrl && x?.VideoUrl.includes("http")
              ? x?.VideoUrl
              // : process.env.VUE_APP_IMG_URL + x?.VideoUrl,
              : x?.VideoUrl,
          ...x,
        }));
        this.Fitems = this.videoDataTableOne;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.Data.totalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
        this.tableLoader = false;
      });
      this.filterDialog = false;
    },
    editRow(row) {
      this.selectedImage = row.ThumbnailImage;
      this.selectedRowData = row;
      this.editvideodialog = true;
    },
    cleanFilter() {
      this.filterObj = {};
    },
    SetModel(item) {
      this.editvideodialog = true;
      this.EditvideoModel = item;
    },
    close() {
      this.editvideodialog = false;
      this.add_dialog = false;
      this.organizeDialog = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      this.snackbar = false;
      this.Deletesnackbar = false;
    },

    closeCategorydialog() {
      this.form.Name = "";
      this.$v.$reset();
      this.newcategorydialog = false;
    },
    showSuccessToast(message = "File has been saved") {
      debugger;
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon:
          message.includes("failed") || message.includes("error")
            ? "error"
            : "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    searchData() {
      this.page = 1;
      this.fetchCategoryData();
    },
    async fetchCategoryData() {
      await this.$store.dispatch("GetVideosCategory");
    },
    send() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else {
        this.btnloader = true;
        this.disabledSavebtn = true;
        this.$store
          .dispatch("CreateVideosCategory", { Name: this.form.Name })
          .then((res) => {
            debugger;
            this.disabledSavebtn = false;
            this.btnloader = false;
            if (res.Status) {
              this.showSuccessToast("Group has been saved");
              this.closeCategorydialog();
              this.fetchCategoryData();
            } else {
              this.showSuccessToast(res.Message);
              this.btnloader = false;
              this.disabledSavebtn = false;
              this.closeCategorydialog();
            }
          })
          .catch((res) => {
            this.showSuccessToast(res.message);
            this.btnloader = false;
            this.disabledSavebtn = false;
            this.closeCategorydialog();
          });
      }
    },
    Visibility() {
      // this.Filter();
    },
    // Filter() {
    //   if (this.search == "") {
    //     if (this.filter == "By Visibility") {
    //       this.Fitems = this.videoDataTableOne.filter((a) => {
    //         if (a.isPlaying) {
    //           return a;
    //         }
    //       });
    //     } else {
    //       this.Fitems = this.videoDataTableOne;
    //     }
    //   } else {
    //     if (this.filter == "") {
    //       this.Fitems = this.videoDataTableOne.filter((a) => {
    //         if (a.Title.toLowerCase().includes(this.search.toLowerCase())) {
    //           return a;
    //         }
    //       });
    //     } else {
    //       if (this.filter === "By Category") {
    //         this.Fitems = this.videoDataTableOne.filter((a) => {
    //           if (
    //             a.CategoryId.toLowerCase().includes(this.search.toLowerCase())
    //           ) {
    //             return a;
    //           }
    //         });
    //       } else if (this.filter === "By Title") {
    //         this.Fitems = this.videoDataTableOne.filter((a) => {
    //           if (a.Title.toLowerCase().includes(this.search.toLowerCase())) {
    //             return a;
    //           }
    //         });
    //       } else if (this.filter === "By Submitted") {
    //         this.Fitems = this.videoDataTableOne.filter((a) => {
    //           if (
    //             a.SubmittedBy.toLowerCase().includes(this.search.toLowerCase())
    //           ) {
    //             return a;
    //           }
    //         });
    //       } else if (this.filter === "By Modality") {
    //         this.Fitems = this.videoDataTableOne.filter((a) => {
    //           if (
    //             a.Modality.toLowerCase().includes(this.search.toLowerCase())
    //           ) {
    //             return a;
    //           }
    //         });
    //       } else if (this.filter === "By Visibility") {
    //         this.Fitems = this.videoDataTableOne.filter((a) => {
    //           if (
    //             a.Title.toLowerCase().includes(this.search.toLowerCase()) &&
    //             a.isPlaying == true
    //           ) {
    //             return a;
    //           }
    //         });
    //       }
    //     }
    //   }
    // },
    preview(row) {
      this.previewvideodialog2 = true;
      this.selectedRowData = row;
      this.test = true;
    },
    closePlayer() {
      this.test = false;
      this.previewvideodialog2 = false;
    },

    async toggleIsPlaying(obj) {
      await this.$store.dispatch("SetVideoVisibility", obj);
      this.fetchVideosList();
    },
  },
};
</script>
<style scoped>
.add_orgranize_btn_mobile {
  display: none;
}
@media screen and (max-width: 430px) {
  .add_orgranize_btn_mobile {
    display: block;
  }
  .add_orgranize_btn_destop {
    display: none;
  }
}
.text_trans {
  text-transform: none;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
